'use strict';

var globalValidation = require('../components/globalValidation');
var mapAPI = require('../components/googleMapsLocation');

/**
 * Override customDropDown.js behavior for try-at-home time slots.
 * Prevents the dropdown from closing when clicking inside .time-slot-dropdown .custom-option-values
 * Dropdown only closes when clicking on a valid (non-strick-out) time slot
 */
document.addEventListener('click', function (e) {
    // allow click if it is a VALID slot
    if (e.target.closest('.time-slot-dropdown .timeslot-values:not(.strick-out)')) {
        return; // allow closing logic
    }

    // block everything else inside dropdown
    if (e.target.closest('.time-slot-dropdown .custom-option-values')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}, true);

/**
 * Validates a slot input field by checking for an empty or whitespace-only value.
 * If invalid, sets a sibling `.custom-feedback` element's text to the error message
 * from the input's `data-error` attribute; otherwise clears the feedback text.
 *
 * @param {JQuery} $slotInput - jQuery-wrapped input element to validate.
 * @returns {boolean} Returns `true` if the slot is invalid (empty/blank), otherwise `false`.
 */
function slotValidation($slotInput) {
    var slotValue = $slotInput.val();
    if (!slotValue || slotValue.trim() === '') {
        $slotInput.siblings('.custom-feedback').text($slotInput.data('error'));
        $('.time-slot-dropdown .custom-drop-down').addClass('is-invalid');
        return true;
    }
    $slotInput.siblings('.custom-feedback').text('');
    $('.time-slot-dropdown .custom-drop-down').removeClass('is-invalid');
    return false;
}

/**
 * Check if a single input field is valid and toggle 'is-invalid' class.
 *
 * @param {JQuery} $input - jQuery input element to validate
 * @returns {void}
 */
function updateFieldValidState($input) {
    var value = $input.val();
    var isEmpty = !value || value.trim() === '';

    $input.toggleClass('is-invalid', isEmpty);
    $input.siblings('.custom-feedback').text(
        isEmpty ? $input.data('missing-error') : ''
    );

    // Sync first name dropdown state
    var fnameInvalid = $('#thfirstName').hasClass('is-invalid');
    $('.try-at-home-fname-group .custom-drop-down-section').toggleClass('is-invalid', fnameInvalid);

    // Sync phone dropdown state
    var phoneInvalid = $('#thphone').hasClass('is-invalid');
    $('.try-at-home-phone-group .custom-drop-down-section').toggleClass('is-invalid', phoneInvalid);
}

/**
 * Resets/sets the customer title selection in the "Try At Home" name section dropdown.
 *
 * Finds the dropdown within `.try-at-home-fname-group`, selects the option matching the
 * provided `customerTitle` (by `data-title` or text), and falls back to the first option
 * when `customerTitle` is not provided or no match is found. Updates the selected option
 * styling and the visible `.selected-value` text accordingly.
 *
 * @function resetCustomerTitle
 * @param {string} [customerTitle=''] - The title to select (e.g., "Mr", "Mrs"). Compared
 *   against each option's `data-title` attribute or its trimmed text content.
 * @returns {void}
 */
function resetCustomerTitle(customerTitle) {
    var enquireFormCustomerTitle = customerTitle || '';
    var $nameSection = $('.try-at-home-fname-group');
    if (!$nameSection.length) return;

    var $dropdown = $nameSection.find('.custom-drop-down-section');
    if (!$dropdown.length) return;

    var $options = $dropdown.find('.custom-option-value');
    if (!$options.length) return;

    var $display = $dropdown.find('.selected-value').first();

    var $targetOption;

    // If customerTitle is passed → select matching option
    if (enquireFormCustomerTitle) {
        $targetOption = $options.filter(function () {
            var title = $(this).attr('data-title') || $(this).text().trim();
            return title === enquireFormCustomerTitle;
        }).first();
    }

    // If NOT passed or not found → select FIRST <li>
    if (!$targetOption || !$targetOption.length) {
        $targetOption = $options.first();
    }

    var nextTitle = $targetOption.attr('data-title') || $targetOption.text().trim();

    // Reset selection
    $options.removeClass('selected');
    $targetOption.addClass('selected');

    // Update visible text
    if ($display.length) {
        $display.text(nextTitle);
    }
}

/**
 * Resets the "Try At Home" phone country code UI to a default value.
 *
 * If a `countryCode` is provided and a matching option exists in the dropdown,
 * that option is selected. Otherwise, the first available option in the list
 * is selected as the default.
 *
 * Side effects:
 * - Updates the displayed selected country code text and applies the `active` class.
 * - Clears existing selection classes and applies `selected` to the chosen option/container.
 * - Hides the dropdown options list(s).
 *
 * @function resetCountryCodeToDefault
 * @param {string} [countryCode] - Country code identifier to select (matches `.custom-option-value[data-id="..."]`).
 * @returns {void}
 */
function resetCountryCodeToDefault(countryCode) {
    var enquireFormCountryCode = countryCode || '';
    var $container = $('.try-at-home-phone-group');
    var $defaultOption;

    // If countryCode is passed → use it
    if (enquireFormCountryCode) {
        $defaultOption = $container
            .find('.custom-option-value[data-id="' + enquireFormCountryCode + '"]')
            .first();
    } else { // Else → pick FIRST option from the list
        $defaultOption = $container.find('.custom-option-value').first();
    }

    if ($defaultOption.length) {
        var defaultCode = $defaultOption.data('id');

        // Update display
        $container.find('.selected-value, .country-selected-value')
            .text(defaultCode)
            .addClass('active');

        // Reset selected states
        $container.find('.custom-option-value, .country-option-item')
            .removeClass('selected');

        $defaultOption.addClass('selected');
        $container.addClass('selected');

        // Hide dropdown
        $container.find('.custom-option-values, .country-dropdown-options').hide();
    }
}

/**
 * Validate Try-At-Home form fields using global input validation helper.
 *
 * Reads the following inputs by ID and runs `globalInputValidation.inputValidation` on each:
 * - #thdate, #thfirstName, #thlastName, #themail, #thphone, #thaddressOne, #thaddressTwo, #thpincode
 *
 * Side effects: each individual validator writes its own error message into a sibling `.custom-feedback` element.
 *
 * @returns {boolean} `true` if any field is invalid (there is an error), otherwise `false`.
 */
function validateForm() {
    var dateError = globalValidation.inputValidation($('#thdate'));
    var slotError = slotValidation($('#selectedTryAtHomeSlot'));
    var fnameError = globalValidation.inputValidation($('#thfirstName'));
    var lnameError = globalValidation.inputValidation($('#thlastName'));
    var mailError = globalValidation.inputValidation($('#themail'));
    var phoneError = globalValidation.inputValidation($('#thphone'));
    var address1Error = globalValidation.inputValidation($('#thaddressOne'));
    var address2Error = globalValidation.inputValidation($('#thaddressTwo'));
    var pincodeError = globalValidation.inputValidation($('#thpincode'));
    var cityError = globalValidation.inputValidation($('#thcity'));
    var termsError = globalValidation.inputValidation($('#tryAtHomeTerms'));

    updateFieldValidState($('#thaddressOne'));
    updateFieldValidState($('#thaddressTwo'));
    updateFieldValidState($('#thpincode'));
    updateFieldValidState($('#thcity'));

    if (dateError) {
        $('#thdate').addClass('is-invalid');
    }

    if (phoneError) {
        $('#thphone').addClass('is-invalid');
        $('.try-at-home-phone-group .custom-drop-down-section').addClass('is-invalid');
    }

    if (mailError) {
        $('#themail').addClass('is-invalid');
    }

    return dateError || slotError || fnameError || lnameError || mailError || phoneError || address1Error || address2Error || pincodeError || cityError || termsError;
}

/**
 * Clean a value for form inputs by removing commas and trimming whitespace.
 *
 * @param {any} v - value to clean (string/number/null/undefined)
 * @returns {string} cleaned string ('' if input falsy)
 */
function clean(v) {
    return v ? String(v).replace(/,/g, '').trim() : '';
}

/**
 * updates the input field values after location id fetched
 *
 * @returns {void} `true` if any field is invalid (there is an error), otherwise `false`.
 */
function fillAddress() {
    try {
        const locationVal = $('#selectedLocation').val();
        if (locationVal) {
            const location = JSON.parse(locationVal);

            if (location && typeof location === 'object') {
                $('#thaddressOne').val(clean(location && location.address1));
                $('#thaddressTwo').val(clean(location && location.address2));
                $('#thpincode').val(clean(location && location.pincode));
                $('#thcity').val(clean(location && location.city));

                updateFieldValidState($('#thaddressOne'));
                updateFieldValidState($('#thaddressTwo'));
                updateFieldValidState($('#thpincode'));
                updateFieldValidState($('#thcity'));
            }
        }
    } catch (error) {
        // console.error('Error parsing or setting location values:', error);
    }
}

/**
 * Clear Try-At-Home modal inputs and reset terms checkbox.
*
* Side effects:
* - Clears values of date, name, email, phone, address and pincode inputs
* - Unchecks the #tryAtHomeTerms checkbox
*
* @returns {void}
*/
function modalClear() {
    $('#thdate, #thfirstName, #thlastName, #themail, #thphone, #thaddressOne, #thaddressTwo, #thpincode').val('');
    $('#tryAtHomeTerms').prop('checked', false);
    resetCustomerTitle();
    resetCountryCodeToDefault();
}

/**
 * Set an input to today's date in dd/mm/yyyy.
 * If bootstrap-datepicker is present, uses its API to keep UI + value consistent.
 *
 * @param {JQuery} $dateInput - date input element
 * @returns {void}
 */
function setTodayDate($dateInput) {
    var today = new Date();

    if ($dateInput && $dateInput.length && $dateInput.datepicker) {
        try {
            $dateInput.datepicker('setDate', today);
            return;
        } catch (e) {
            // fall through to manual value set
        }
    }

    var day = ('0' + today.getDate()).slice(-2);
    var month = ('0' + (today.getMonth() + 1)).slice(-2);
    var year = today.getFullYear();
    $dateInput.val(day + '/' + month + '/' + year);
}

/**
 * Fetches city information based on a pincode using Google Maps Geocoding API
 * and populates the city input field with the result.
 * @param {string|number} pincode - The postal/pin code to look up
 * @returns {void}
 */
function fetchPlace(pincode) {
    var country = 'India';
    var googleApiKey = $('#google-maps-api-key').val();
    var apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + pincode + ',' + country + '&key=' + googleApiKey;

    $.getJSON(apiUrl, function (data) {
        $('#thcity').val('');

        if (data.status === 'OK' && data.results.length) {
            var result = data.results[0];
            var city = '';

            result.address_components.forEach(function (component) {
                if (component.types.includes('locality')) {
                    city = component.long_name;
                }
            });

            if (city) $('#thcity').val(city).trigger('input');
        }
    });
}

/**
 * Sends Try At Home data to the server and
 * updates the DOM with available time slots.
 *
 * @function updateTimeSlots
 * @returns {void}
 */
function updateTimeSlots() {
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var selectedDate = $('#thdate').val();
    var selectedTryAtHomeSlot = $('#selectedTryAtHomeSlot').val();
    var url = $('#tryAtHomeTimeDropdown').data('url');

    var tryAtHomeData = {
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        selectedTryAtHomeSlot: selectedTryAtHomeSlot || ''
    };
    $.ajax({
        url: url,
        method: 'POST',
        data: tryAtHomeData,
        success: function (data) { // eslint-disable-line no-unused-vars
            if (data.success === false) {
                $('#tryAtHomeForm .pickup-slot-scroll').addClass('d-none');
            } else {
                $('#tryAtHomeForm .pickup-slot-scroll').removeClass('d-none');
                $('#tryAtHomeTimeSlots').html(data);
                $('#tryAtHomeForm .pickup-slot-scroll').scrollTop(0);
            }
        }
    });
}

/**
 * Scroll to the first error message in the modal
 */
function scrollToFirstError() {
    var $form = $('#tryAtHomeForm');
    var $firstError = $form.find('.is-invalid').filter(':visible').first();

    if ($firstError.length === 0) {
        $firstError = $form.find('.custom-feedback').filter(function () {
            return $(this).text().trim().length > 0 && $(this).is(':visible');
        }).first();
    }

    if ($firstError.length) {
        var $scrollContainer = (window.innerWidth < 992) ? $form : $('#tryAtHomeModal .modal-body');

        if ($scrollContainer.length) {
            var scrollPos = $scrollContainer.scrollTop() + ($firstError.offset().top - $scrollContainer.offset().top) - 100;
            $scrollContainer.animate({
                scrollTop: scrollPos
            }, 500);
        }
    }
}

/**
 * Fetches the user's current location using map API
 * and updates the selected address field.
 *
 * @returns {void}
 */
function fetchCurrentLocationFromMapAPI() {
    mapAPI.getCurrentLocationWithAddress()
        .then(({ address }) => {
            $('#selectedLocation').val(JSON.stringify(address));
            fillAddress();
            $.spinner().stop();
        })
        .catch(() => {
            $.spinner().stop();
            if (!$('.location-permission-error').hasClass('opened-once') && $('#tryAtHomeModal').hasClass('enabled')) {
                $('.location-permission-error').removeClass('d-none');
            }
        });
}

/**
 * Opens the map modal and initializes Google Maps only when needed.
 *
 * @returns {void}
 */
function openLocateOnMapModal() {
    $('#tryAtHomeModal').modal('hide');
    $('#locateOnMapModal').modal('show');

    mapAPI.initMap().then(function (map) {
        if (map && window.google && window.google.maps) {
            window.google.maps.event.trigger(map, 'resize');
        }
    }).catch(function () {
        // Errors are surfaced by the current-location and loader flows.
    });
}

var tryAtHomeModalPromise;

/**
 * Loads the Try At Home modal markup only when the CTA is opened.
 *
 * @param {jQuery} $trigger - The CTA that requested the modal.
 * @returns {Promise<void>} Resolves once the modal markup is available.
 */
function ensureTryAtHomeModalLoaded($trigger) {
    var $existingModal = $('#tryAtHomeModal');
    var url = $trigger.data('url');
    var $container = $('#tryAtHomeModalContainer');

    if ($existingModal.length && $container.attr('data-loaded-url') === url) {
        return Promise.resolve();
    }

    if (tryAtHomeModalPromise) {
        return tryAtHomeModalPromise;
    }

    tryAtHomeModalPromise = new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'html',
            success: function (html) {
                if ($container.length) {
                    $container.html(html);
                    $container.attr('data-loaded-url', url);
                } else {
                    $('body').append(html);
                }

                resolve();
            },
            error: function (xhr, statusText, errorThrown) {
                reject(new Error(errorThrown || statusText || 'Unable to load Try At Home modal.'));
            }
        });
    });

    tryAtHomeModalPromise = tryAtHomeModalPromise.then(function () {
        tryAtHomeModalPromise = null;
    }, function (error) {
        tryAtHomeModalPromise = null;
        throw error;
    });

    return tryAtHomeModalPromise;
}

/**
 * Opens the Try At Home flow once the modal markup is available.
 */
function openTryAtHomeFlow() {
    if ($('.isLoggedInUser').length !== 0 && $('.isLoggedInUser').val() === 'true') {
        $('#tryAtHomeModal').addClass('enabled');
        var holidaysData = $('#tryAtHomeHolidaysData').val();
        var allHolidayData = holidaysData ? JSON.parse(holidaysData) : [];
        var holidays = [];
        if (allHolidayData && allHolidayData.commonHolidays && Array.isArray(allHolidayData.commonHolidays)) {
            holidays = holidays.concat(allHolidayData.commonHolidays);
        }

        // Convert holidays array to Set for faster lookup
        var holidaysSet = {};
        holidays.forEach(function (date) {
            holidaysSet[date] = true;
        });

        var $dateInput = $('.bopis-form-date-input');
        if ($dateInput.length) {
            $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            $dateInput
                .datepicker('destroy')
                .datepicker({
                    format: 'dd/mm/yyyy',
                    language: 'en',
                    autoclose: true,
                    todayHighlight: false,
                    startDate: '+0d',
                    weekStart: 1,
                    maxViewMode: 2,
                    beforeShowDay: function (date) {
                        // Format date to DD/MM/YYYY to match holiday format
                        var day = ('0' + date.getDate()).slice(-2);
                        var month = ('0' + (date.getMonth() + 1)).slice(-2);
                        var year = date.getFullYear();
                        var dateString = day + '/' + month + '/' + year;

                        // Check if date is in holidays set
                        var isHoliday = holidaysSet[dateString] === true;

                        // Return false to disable the date if it's a holiday
                        return !isHoliday;
                    }
                })
                .on('show', function (event) { event.stopPropagation(); });

            // Default selected date to today when opening the modal
            setTodayDate($dateInput);
        }
        var customer = JSON.parse($('#customerData').val());
        resetCustomerTitle(customer.customerTitle);
        $('#thfirstName').val(customer.firstName);
        $('#thlastName').val(customer.lastName);
        $('#themail').val(customer.email);
        resetCountryCodeToDefault(customer.mobileDialingCode);
        $('#thphone').val(customer.phone);
        $('#tryAtHomeModal').modal('show');
        $('#tryAtHomeTimeDropdown .custom-drop-down').removeClass('is-invalid');

        // scroll to top of modal
        $('#tryAtHomeModal .modal-body').scrollTop(0);

        if ($('#thTryAtSlot').text() === $('#thTryAtSlot').data('altxt')) {
            $('#selectedTryAtHomeSlot').val('');
        }

        $('.custom-feedback').text('');
        $('#tryAtHomeSubmit').removeClass('pressed');
        $('#tryAtHomeForm input').removeClass('is-invalid');
        $('#thaddressOne, #thaddressTwo, #thpincode, #thcity').val('');
        $('#tryAtHomeTerms').prop('checked', false);
        $('.try-at-home-fname-group .custom-drop-down-section').removeClass('is-invalid');
        $('.try-at-home-phone-group .custom-drop-down-section').removeClass('is-invalid');
    } else {
        $('#ckc-login-modal').modal('show');

        var $wrap = $('.ckc-login-countrycode-drop-down');
        $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
        var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
        $defaultOption.addClass('active selected');
        $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
        $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
    }
}

$(document).on('click', '.try-at-home-btn', function (e) {
    e.preventDefault();
    var $trigger = $(this);

    ensureTryAtHomeModalLoaded($trigger).then(function () {
        openTryAtHomeFlow();
    }).catch(function () {
        // Keep the CTA inert on fetch failure instead of breaking the page.
    });
});

$(document).ready(function () {
    modalClear();

    $('body').on('input', '#thphone, #thpincode', function () {
        $(this).val(this.value.replace(/\D/g, ''));

        if ($(this).hasClass('try-at-home-pincode')) {
            fetchPlace($(this).val());
        }
    });

    $('body').on('input', '#thfirstName, #thlastName', function () {
        if ($(this).val().trim() === '') {
            $(this).val('');
        }
        $(this).val(this.value.replace(/[^a-zA-Z\s]/g, ''));
    });

    $('body').on('input', '#tryAtHomeForm input', function () {
        // Only validate the current input being edited
        updateFieldValidState($(this));
    });

    $(document).on('click', '.bopis-form-date-input', function () {
        $('.table-condensed .prev').text('');
        $('.table-condensed .next').text('');
    });

    $(document).on('change', '#thdate', function () {
        if ($(this).val().trim() === '') {
            $(this).addClass('is-invalid');
            $(this).siblings('.custom-feedback').text($(this).data('missing-error'));
            return;
        }
        $(this).removeClass('is-invalid');
        $(this).siblings('.custom-feedback').text('');

        var altxt = $('#thTryAtSlot').data('altxt');
        if (altxt && altxt.length > 0) {
            $('#thTryAtSlot').text(altxt);
            $('#selectedTryAtHomeSlot').val('');
        }
        var $tryAtHomeTimeDropdown = $('#tryAtHomeTimeDropdown');
        $tryAtHomeTimeDropdown.find('.custom-drop-down').removeClass('is-invalid');
        $tryAtHomeTimeDropdown.siblings('.custom-feedback').text('');

        // Refresh the DOM time slots based on the new date selection
        updateTimeSlots();
    });

    $('body').on('click', '#tryAtHomeTimeSlots .timeslot-values:not(.strick-out)', function () {
        var $selectedTryAtHomeSlot = $('#selectedTryAtHomeSlot');
        var selectedSlot = $(this).data('value');
        $selectedTryAtHomeSlot.val(selectedSlot);
        $selectedTryAtHomeSlot.siblings('.custom-feedback').text('');
        $('.time-slot-dropdown .custom-drop-down').removeClass('is-invalid');

        // Close the dropdown only for valid (non-strick-out) slots
        var $dropdown = $(this).closest('.custom-option-values');
        $dropdown.hide();
        $dropdown.prev('.custom-drop-down')
            .removeClass('opened')
            .find('.down-arrow')
            .removeClass('rotate-arrow');
    });

    $('body').on('click', '.try-at-home-phone-group .custom-option-value', function () {
        var $phoneInput = $('#thphone');
        $phoneInput.val('');
        $phoneInput.removeClass('is-invalid');
        $phoneInput.siblings('.custom-feedback').text('');
        $('.try-at-home-phone-group .custom-drop-down-section').removeClass('is-invalid');
    });

    $(document).on('click', '#tryAtHomeTimeDropdown', function () {
        if (!$('#tryAtHomeTimeDropdown').hasClass('opened')) {
            var customerPhone = $('.customerPhone').val();
            var customerEmail = $('.customerEmail').val();
            var selectedDate = $('#thdate').val();
            var selectedTryAtHomeSlot = $('#selectedTryAtHomeSlot').val();
            var url = $(this).data('url');

            var tryAtHomeData = {
                customerPhone: customerPhone,
                customerEmail: customerEmail,
                selectedDate: selectedDate,
                selectedTryAtHomeSlot: selectedTryAtHomeSlot || ''
            };
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: tryAtHomeData,
                success: function (data) { // eslint-disable-line no-unused-vars
                    $.spinner().stop();
                    if (data.success === false) {
                        $('#tryAtHomeForm .pickup-slot-scroll').addClass('d-none');
                        var $tryAtHomeTimeDropdown = $('#tryAtHomeTimeDropdown');
                        $tryAtHomeTimeDropdown.find('.custom-drop-down').addClass('is-invalid');
                        var slotNotAvailableMessage = $('#thTryAtSlot').data('slot-not-available');
                        $tryAtHomeTimeDropdown.siblings('.custom-feedback').text(slotNotAvailableMessage);
                    } else {
                        $('#tryAtHomeForm .pickup-slot-scroll').removeClass('d-none');
                        $('#tryAtHomeTimeSlots').html(data);
                        $('#tryAtHomeForm .pickup-slot-scroll').scrollTop(0);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    // When the user clicks the terms and conditions checkbox
    $('body').on('click', '.terms-group.ckc-checkbox', function () {
        if ($('#tryAtHomeTerms').prop('checked')) {
            $('#tryAtHomeTerms').prop('checked', false);
        } else {
            $('#tryAtHomeModal').modal('hide');
            $('#terms-modal.tryAtHome').modal('show');
        }
    });

    // When the user clicks the "Agree & Continue" button in the terms modal
    $('body').on('click', '#tryAtHomeTermsAgree', function () {
        $('#terms-modal.tryAtHome').modal('hide');
        $('#tryAtHomeModal').modal('show');
        $('#tryAtHomeTerms').prop('checked', true);
        $('#tryAtHomeTerms').siblings('.custom-feedback').text('');
    });

    // When the terms modal is hidden (closed)
    $(document).on('hidden.bs.modal', '#terms-modal.tryAtHome', function () {
        $('#terms-modal.tryAtHome').modal('hide');
        $('#tryAtHomeModal').modal('show');
    });

    $('body').on('click', '.timeslot-values', function () {
        $('#timeslotValue').val($(this).data('value'));
    });

    $('body').on('click', '.city-value', function () {
        $('#thCities').val($(this).data('value'));
    });

    $('body').on('click', '#tryAtHomeSubmit', function () {
        var error = validateForm();
        var customerTitle = $('.try-at-home-fname-group .selected-value').text().trim();
        var customerCountryCode = $('.try-at-home-phone-group #select-country-code').text().trim();

        if (!customerTitle || !customerCountryCode) {
            error = true;
        }

        if (!error) {
            var $data = $('.try-at-home-inputs');
            var url = $data.find('#tryAtHomeUrl').val();
            var thTryAtSlot = $('#selectedTryAtHomeSlot').val();
            var formData = $('#tryAtHomeForm').serialize() + '&thTryAtSlot=' + thTryAtSlot + '&customerTitle=' + customerTitle + '&customerCountryCode=' + customerCountryCode;
            $.ajax({
                url: url,
                method: 'POST',
                data: formData,
                dataType: 'json',
                success: function (data) {
                    if (data.valid) {
                        $('#tryAtHomeModal').modal('hide');
                        $('#tryathomeconfirmationmodal').modal('show');
                        $('.location-value').text(data.confirmationData.address);
                        $('.date-value').text(data.confirmationData.date);
                        $('.slot-value').text(data.confirmationData.slot.replace('-', ' to '));
                    } else {
                        validateForm();
                        scrollToFirstError();
                    }
                }
            });
        } else {
            $('#tryAtHomeSubmit').addClass('pressed');
            scrollToFirstError();
        }
    });

    $('body').on('click', '.btn-edit-tryAtHome', function () {
        $('#tryathomeconfirmationmodal').modal('hide');
        $('#tryAtHomeModal').modal('show');
    });

    $('body').on('click', '.btn-confirm-tryAtHome', function () {
        var address = $('#tryathomeconfirmationmodal .location-value').text();
        var date = $('#tryathomeconfirmationmodal .date-value').text();
        var slot = $('#tryathomeconfirmationmodal  .slot-value').text();
        var pid = $('.productId').val();
        var url = $('#tryAtHomeConfirmUrl').val();
        var confirmData = {
            productID: pid,
            address: address,
            date: date,
            slot: slot.replace(' to ', '-')
        };
        $.ajax({
            url: url,
            method: 'POST',
            data: confirmData,
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    $('#tryathomeconfirmationmodal').modal('hide');
                    $('#tryathomesuccessmodal').modal('show');
                    $('.location-value').text(data.confirmationData.address);
                    $('.date-value').text(data.confirmationData.date);
                    $('.slot-value').text(data.confirmationData.slot.replace('-', ' to '));
                    modalClear();
                } else {
                    $('#tryathomeconfirmationmodal').modal('hide');
                    var $errorModal = $('#allreadyhaveresponsetryatshowroom');
                    if (data.message) {
                        $errorModal.find('.message-text').text(data.message);
                    }
                    $errorModal.modal('show');
                    setTimeout(function () {
                        $errorModal.modal('hide');
                    }, 3000);
                }
            }
        });
    });

    $('body').on('click', '#btnLocateOnMap', function (e) {
        e.preventDefault();
        openLocateOnMapModal();
    });

    $('body').on('click', '.btn-cancel-location', function () {
        $('#selectedLocation').val('');
        $('#locateOnMapModal').modal('hide');
        $('#tryAtHomeModal').modal('show');
    });

    $('body').on('click', '.btn-confirm-location', function () {
        mapAPI.updateLatLng($('#selectedLocation'));
        $('#locateOnMapModal').modal('hide');
        $('#tryAtHomeModal').modal('show');

        fillAddress();
    });

    $('body').on('click', '#btnCurrentLocation', function (e) {
        e.preventDefault();
        $.spinner().start();

        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                if (result.state === 'denied') {
                    $.spinner().stop();

                    // eslint-disable-next-line no-alert
                    alert('Location access is denied. Please enable it in your browser settings.');
                } else {
                    fetchCurrentLocationFromMapAPI();
                }
            });
        } else {
            fetchCurrentLocationFromMapAPI();
        }
    });

    $('body').on('click', '.location-permission-error, .location-permission-close', function () {
        $('.location-permission-error').addClass('d-none').addClass('opened-once');
    });

    $('body').on('click', '.error-popup', function (e) {
        e.stopPropagation();
    });
});
